import React from 'react';
import '../../styles/Skeleton.css'; // Reutilizamos los estilos que ya tienes

const TableSkeleton = ({ rows = 5, columns = 4 }) => {
    return (
        <div className="report-table-container">
            <table className="report-table">
                <thead>
                    <tr>
                        {Array.from({ length: columns }).map((_, i) => (
                            <th key={i}><div className="skeleton skeleton-text" style={{ width: '70%' }}></div></th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: rows }).map((_, i) => (
                        <tr key={i}>
                            {Array.from({ length: columns }).map((_, j) => (
                                <td key={j}><div className="skeleton skeleton-text"></div></td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableSkeleton;